import React, { useState, useEffect, useRef } from 'react';
import TweenOne from 'rc-tween-one';
import ScrollAnim from 'rc-scroll-anim';
import QueueAnim from 'rc-queue-anim';

import Menu from '../../components/menu';
import Button from '../../components/button';
import InputButton from '../../components/input-button';
import p02 from '../../static/images/p02.png';

import FeatureBase from './feature-base';
import FeatureMore from './feature-more';
import Price1 from './price1';
import Price2 from './price2';
import Price3 from './price3';

import handleChat, { sendNumber } from '../../utils/handle-chat';

import './style.css';

const ScrollOverPack = ScrollAnim.OverPack;

const a_l = {
  x: '-=100',
  opacity: 0,
  duration: 600,
  type: 'from'
};
const a_r = {
  x: '+=100',
  opacity: 0,
  duration: 600,
  type: 'from'
};
const a_b = {
  y: '+=100',
  opacity: 0,
  duration: 600,
  type: 'from'
};
const s_a_b = {
  type: 'bottom',
  duration: 600,
  animConfig: {
    type: 'from',
    y: '+=100'
  }
};

const Detail = () => {
  const root = useRef(null);
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const handlePhone = () => {
    if (!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(phone)) {
      setPhoneError(true);
      return;
    }
    const content = `在线客服-免费试用，手机号：${phone}`;
    setPhoneError(false);
    sendNumber(phone);
    handleChat(content, ['d1', 'type2']);
  };

  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: 0
    });
  }, []);

  return (
    <>
      <Menu type="single" />
      <div id="detail" ref={root} className="detail">
        <div className="detail-1">
          <TweenOne animation={a_l} className="detail-1-left">
            <h1 key="h1">在线客服</h1>
            <h3 key="h3">只需20元，即刻开启你的对话新方式</h3>
            <InputButton
              key="btn"
              className={phoneError ? 'error' : ''}
              placeholder="请输入你的手机号"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              onSubmit={handlePhone}>
              免费试用
            </InputButton>
          </TweenOne>
          <TweenOne animation={a_r} className="detail-1-right">
            <img src={p02} alt="在线客服" />
          </TweenOne>
        </div>
        <TweenOne animation={a_b} className="detail-2">
          <h2>
            基础产品<i className="tag">20元/月</i>
          </h2>
          <h3>包含2个坐席，如果你只有对话需求，选它</h3>
          <FeatureBase />
          <div className="btns">
            <Button type="primary" onClick={() => handleChat('立即购买基础产品', ['d2', 'type1'])}>
              立即购买
            </Button>
            <Button onClick={() => handleChat('免费试用基础产品', ['d2', 'type2'])}>免费试用</Button>
          </div>
        </TweenOne>
        <ScrollOverPack playScale={0.3} className="detail-3">
          <QueueAnim {...s_a_b}>
            <h2 key="h1">更多功能...</h2>
            <h3 key="h3">超低价格，按月购买，灵活搭配</h3>
          </QueueAnim>
          <FeatureMore />
        </ScrollOverPack>
        <ScrollOverPack playScale={0.3} className="detail-4">
          <QueueAnim {...s_a_b}>
            <h2 key="h2">推荐搭配</h2>
            <h4 key="h4">
              功能太多，选择恐惧，别担心，我们为你准备了组合套餐，
              <br />
              3个月起售，超值优惠，付费时间越长优惠越多，直接购买1年可享受
              <span style={{ color: '#705DED', fontWeight: '600' }}>折上折优惠</span>
            </h4>
            <div key="p" className="prices">
              <Price1 />
              <Price2 />
              <Price3 />
            </div>
          </QueueAnim>
        </ScrollOverPack>
        <ScrollOverPack playScale={0.3} className="detail-5">
          <QueueAnim {...s_a_b}>
            <h2 key="h2">找到适合你的计划</h2>
            <h3 key="h3">多种功能，按需定制，自由组合</h3>
          </QueueAnim>
          <div key="row1" className="row">
            <TweenOne animation={a_l} className="row-1-1">
              <strong>基础产品</strong>
              <p>只需要对话，选它</p>
            </TweenOne>
            <TweenOne animation={a_r} className="row-1-2">
              <strong>基础产品+自选功能</strong>
              <p>需求较少，想加购几个其它功能</p>
            </TweenOne>
          </div>
          <div key="row2" className="row">
            <TweenOne animation={a_l} className="row-2-1">
              <strong>购买套餐</strong>
              <p>需求较多，选择恐惧，想要超值优惠，选它</p>
            </TweenOne>
            <TweenOne animation={a_r} className="row-2-2">
              <strong>套餐+自选功能</strong>
              <p>要优惠，也要个性化</p>
            </TweenOne>
          </div>
          <div key="btn" className="btns">
            <Button type="primary" onClick={() => handleChat('立即购买按需定制', ['d10', 'type1'])}>
              立即购买
            </Button>
          </div>
          <div className="copyright">
            Copyright © 2020 匠人来了科技成都有限公司
            <a target="_blank" rel="noopener noreferrer" href="http://sc.beian.miit.gov.cn">
              蜀ICP备20004120号
            </a>
          </div>
        </ScrollOverPack>
      </div>
    </>
  );
};

export default Detail;
